export default "__VITE_ASSET__CPwWCxtu__"